import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LeadPreferenceForm from '../components/LeadPreferenceForm';
import { leadSuggestionService } from '../services/leadSuggestionService';

const OnboardingLeadPreferences: React.FC = () => {
  const navigate = useNavigate();
  const [skipping, setSkipping] = useState(false);

  const handleSkip = async () => {
    setSkipping(true);
    try {
      const prefs = await leadSuggestionService.getLeadPreferences();
      await leadSuggestionService.updateLeadPreferences({
        enabled: true,
        scoring_weights: prefs.preset_options?.default_scoring_weights,
        priority_preferences: prefs.preset_options?.lead_qualification_priorities,
        lead_qualification_priorities: prefs.preset_options?.lead_qualification_priorities,
      });
      navigate('/');
    } catch {
      navigate('/');
    } finally {
      setSkipping(false);
    }
  };

  return (
    <div className="min-h-screen bg-app py-10 px-4">
      <div className="max-w-3xl mx-auto space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-fg">Lead Suggestion Preferences</h1>
          <p className="text-sm text-fg-muted mt-2">
            Tell us who you serve and where you work. LaunchPoint will automatically choose the best lead sources for you.
          </p>
        </div>

        <div className="rounded-xl border border-border bg-surface p-6">
          <LeadPreferenceForm
            onSaved={() => navigate('/leads/suggestions')}
          />
        </div>

        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={handleSkip}
            disabled={skipping}
            className="text-sm text-fg-muted hover:text-fg"
          >
            {skipping ? 'Skipping...' : 'Skip for now (use defaults)'}
          </button>
          <Link to="/" className="text-sm text-primary hover:underline">
            Go to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OnboardingLeadPreferences;
